<div class="position-relative">
  <input
    class="input-base trailing-icon-padding"
    autoComplete="off"
    [floatUi]="datePicker"
    (onShown)="onDatePickerVisibilityChange(true)"
    (onHidden)="onDatePickerVisibilityChange(false)"
    [showTrigger]="NgxFloatUiTriggers.click"
    [placement]="NgxFloatUiPlacements.BOTTOMSTART"
    [hideOnScroll]="true"
    [positionFixed]="true"
    [preventOverflow]="true"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
      'input-error': error(),
      disabled: disabled(),
    }"
    [type]="'text'"
    [attr.id]="controlId()"
    [value]="inputStringValue()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [maskito]="maskitoOptions"
    (input)="handleInput($event)"
    (blur)="onBlur()"
    (focus)="onFocus()">
  <mat-icon
    class="input-trailing-icon"
    [class]="{
      'input-trailing-icon-large': inputSize() === InputSize.large,
      'input-trailing-icon-small': inputSize() === InputSize.small,
      disabled: disabled(),
    }"
    [svgIcon]="'calendar'">
  </mat-icon>
</div>

<float-ui-content #datePicker>
  <lib-date-picker
    [date]="currentSelectedDate()"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
    (result)="handleDatePickerResult($event)"
    (hide)="datePicker.hide()"
    [useFutureYearOptions]="useFutureYearOptions()"></lib-date-picker>
</float-ui-content>
